import { JSX } from "react";

type AllowedTag = "b" | "i" | "u";

interface HtmlTextProps {
  text: string;
  tag: AllowedTag
};

const TAGS: Record<AllowedTag, { start: string; end: string; wrap: (c: React.ReactNode, key?: React.Key) => JSX.Element }> = {
  b: { start: "<b>", end: "</b>", wrap: (c, key) => <b key={key}>{c}</b> },
  i: { start: "<i>", end: "</i>", wrap: (c, key) => <i key={key}>{c}</i> },
  u: { start: "<u>", end: "</u>", wrap: (c, key) => <u key={key}>{c}</u> },
};

const HtmlText: React.FC<HtmlTextProps> = ({ text, tag = "b" }) => {
  const { start, end, wrap } = TAGS[tag];

  const renderHtml = () => {
    const chunks = text.split(start);
    if (chunks.length === 1) return text;

    const nodes: React.ReactNode[] = [];
    nodes.push(chunks[0]);

    for (let i = 1; i < chunks.length; i++) {
      const seg = chunks[i];
      const closeIdx = seg.indexOf(end);
      if (closeIdx !== -1) {
        const styledText = seg.slice(0, closeIdx);
        const rest = seg.slice(closeIdx + end.length);
        nodes.push(wrap(styledText, `tag-${i}`));
        nodes.push(rest);
      } else {
        nodes.push(start + seg);
      }
    }

    return <span>{nodes}</span>;
  };


  return <div className="chat-text text-white text-lg chat-text--bot">
    {renderHtml()}
  </div>
};

export default HtmlText;